<template>
  <HubContainer id="branchMarketingHub">

    <template v-if="multiInventoryActivated">
      <HubSection large icon="icon/hub/promo.svg"
                  :title="$t('promotions.title')"
                  :description="$t('promotions.subtitle')"
                  :buttonAction="goToPromos">
      </HubSection>

      <HubSection large icon="icon/hub/promo-popup.svg"
                  :title="$t('promotions.modal.title')"
                  :description="$t('promotions.modal.subtitle')"
                  :buttonAction="goToPromoPopup">
      </HubSection>
    </template>

    <HubSection large icon="icon/hub/newsletter.svg"
                :title="$t('mailchimp.newsletter')"
                :description="$t('mailchimp.newsletter_description')"
                :buttonAction="goToNewsletter">
    </HubSection>

  </HubContainer>
</template>

<script>
import HubSection from "@/components/HubSection";
import HubContainer from "@/components/HubContainer";

export default {
  name: "BranchMarketingHub",

  components: { HubSection, HubContainer },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "inventory.selection";
    this.$store.state.pageIcon = "/icon/menu.svg";
  },

  computed: {
    branch() {
      return this.$store.state.contextBranch;
    },
    multiInventoryActivated() {
      return this.branch ? this.branch.inventories.length > 0 : false;
    },
  },

  methods: {
    goToPromos() {
      this.$router.push(this.$router.buildContext("/promotions"));
    },
    goToPromoPopup() {
      this.$router.push(this.$router.buildContext("/promotion-modal"));
    },
    goToNewsletter() {
      this.$router.push(this.$router.buildContext("/newsletter"));
    }
  }
}
</script>